import { Component, OnInit, inject, Output, EventEmitter, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { RuleService } from '../../services/rule.service';
import { AppSettings } from '@services/settings/app-settings.service';
import { ListCardComponent } from 'app/core/components/list-card/list-card.component';
import { MobileFooterComponent } from 'app/core/components/mobile-footer/mobile-footer.component';

@Component({
    selector: 'app-rule-list',
    standalone: true,
    imports: [CommonModule, NgSelectModule, FormsModule, ListCardComponent, MobileFooterComponent],
    templateUrl: './rule-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './rule-list.component.css'
})
export class RuleListComponent implements OnInit {

    rules: any[] = [];
    filteredRules: any[] = [];
    rulesSelected: any[] = [];
    searchText = '';
    public appSettings = inject(AppSettings);

    isLoading = true;
    rows = Array.from({ length: 5 }, (_, i) => i + 1);

    public order: boolean = true;
    public orderColName: string = 'description';
    selectedId = signal<any>(null);

    private ruleService = inject(RuleService);

    @Output() selectEvent = new EventEmitter<any>();

    constructor() { }

    ngOnInit(): void {
        this.loadRules();
    }

    loadRules() {
        this.isLoading = true;
        this.ruleService.get().subscribe({
            next: (res) => {
                this.rules = res;
                this.changeSelect();
                this.isLoading = false;
            },
            error: (err) => {
                console.error(err);
                this.isLoading = false;
            }
        });
    }

    changeSelect() {
        let list = [...this.rules];
        if (this.rulesSelected && this.rulesSelected.length > 0) {
            list = list.filter(b => this.rulesSelected.includes(b.slug || b.code));
        }
        const term = (this.searchText || '').trim().toLowerCase();
        if (term) {
            list = list.filter((r) =>
                [r.slug, r.code, r.description, r.value]
                    .filter(Boolean)
                    .some((v) => String(v).toLowerCase().includes(term))
            );
        }
        this.filteredRules = list;
        this.applyOrder();
    }

    orderCol(col: string) {
        if (this.orderColName === col) {
            this.order = !this.order;
        } else {
            this.orderColName = col;
            this.order = true;
        }
        this.applyOrder();
    }

    applyOrder() {
        this.filteredRules.sort((a, b) => {
            const valA = a[this.orderColName];
            const valB = b[this.orderColName];

            if (typeof valA === 'string' && typeof valB === 'string') {
                return this.order ? valA.localeCompare(valB) : valB.localeCompare(valA);
            } else {
                return this.order ? valA - valB : valB - valA;
            }
        });
    }

    selectRule(rule: any) {
        this.selectedId.set(rule.id);
        this.selectEvent.emit(rule);
    }
}
